import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from 'vue';
import QRCode from 'qrcode';
import { useI18n } from 'vue-i18n';
import AuthService from '@/services/api/AuthService';
import router from '@/router';
import { useUiStore, useAuthStore } from '@/stores';
import { toastServiceError } from '@/services';


export default /*@__PURE__*/_defineComponent({
  __name: 'TwoFaAuthenticatorPage',
  setup(__props, { expose: __expose }) {
  __expose();

const { t } = useI18n();

const qrCodeUrl = ref('');

const formState = ref({
    code: '',
    remember: false,
});

const uiStore = useUiStore();
const authStore = useAuthStore();

const setLoading = (loading: boolean) => uiStore.setIsLoading(loading);

const twoFactorEnabled = computed(() => authStore.user && authStore.user.twoFactorEnabled);

const twoFaSetup = async () => {
    try {
        const response = await AuthService.twoFaSetup();
        qrCodeUrl.value = await QRCode.toDataURL(response.data.otpAuthUrl);
    } catch (err) {
        await router.push('/login');
        console.error(err);
    }
};

const twoFaVerifySetup = async () => {
    if (!formState.value.code) {
        toastServiceError(t('authentication.2fa.error.enterCode'));
        return;
    }
    try {
        setLoading(true);
        const { data } = await AuthService.twoFaVerifySetup({
            code: formState.value.code,
            remember: formState.value.remember,
        });
        authStore.login(data);

        await router.push('/');
    } catch (error) {
        console.log(error);
        toastServiceError(error);
    } finally {
        setLoading(false);
    }
};

const twoFaVerify = async () => {
    if (!formState.value.code) {
        toastServiceError(t('authentication.2fa.error.enterCode'));
        return;
    }
    try {
        setLoading(true);
        const { data } = await AuthService.twoFaVerify({
            code: formState.value.code,
            remember: formState.value.remember,
        });

        authStore.login(data);
        await router.push('/');
    } catch (error) {
        console.log(error);
        toastServiceError(error);
    } finally {
        setLoading(false);
    }
};

const verify = async () => {
    if (twoFactorEnabled.value) {
        await twoFaVerify();
    } else {
        await twoFaVerifySetup();
    }
};

onMounted(async () => {
    if (!twoFactorEnabled.value) {
        await twoFaSetup();
    }
});

const __returned__ = { t, qrCodeUrl, formState, uiStore, authStore, setLoading, twoFactorEnabled, twoFaSetup, twoFaVerifySetup, twoFaVerify, verify }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})